import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import _ from 'lodash';

import IconButton from 'material-ui/IconButton';
import AutoComplete from 'material-ui/AutoComplete';
import ContentRemoveIcon from 'material-ui/svg-icons/content/remove-circle-outline';

import ColorPickerPopup from './ColorPickerPopup';

class RuleItem extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            rules: [],
            types: [],
        };

        this.removeRule = this.removeRule.bind(this);
        this.filterAutoComplete = this.filterAutoComplete.bind(this);
        this.onInputAutoComplete = this.onInputAutoComplete.bind(this);
        this.changeColor = this.changeColor.bind(this);
    }

    changeColor(indexLevel, indexRule, color) {
        const { levelList, changeLevelList, rule } = this.props;

        levelList[indexLevel].rulesList[indexRule] = {
            ...rule,
            color,
        };

        changeLevelList(levelList);
    }

    removeRule(indexLevel, indexRule) {
        const { levelList, changeLevelList } = this.props;

        levelList[indexLevel].rulesList.splice(indexRule, 1);

        changeLevelList(levelList);
    }

    onInputAutoComplete(indexLevel, indexRule, type, value) {
        const { levelList, changeLevelList, rule } = this.props;

        levelList[indexLevel].rulesList[indexRule] = {
            ...rule,
            [type]: value,
        };

        changeLevelList(levelList);
    }

    filterAutoComplete(searchText, key) {
        const regExp = new RegExp(searchText, 'i');

        return regExp.test(key.toLowerCase());
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        let rules = [];

        nextProps.annotations.forEach((item) => {
            if (item.features.rule) {
                rules.push(item.features.rule);
            }
        });

        rules = _.uniq(rules);

        let types = nextProps.annotations.map((item) => {
            return item.type;
        });

        types = _.uniq(types);

        this.setState({
            rules,
            types,
        });
    }

    render() {
        const { rules, types } = this.state;
        const { rule, indexRule, indexLevel, disabledActions } = this.props;

        return (
            <div className="paper-block">
                <span className='name-block absolute small-name'>Type of rule - {rule.typeOfRule}</span>
                <div className="row">
                    <div className="col-xs-4">
                        <AutoComplete
                            searchText={rule.rule}
                            dataSource={rules}
                            floatingLabelText='Rule'
                            onUpdateInput={(value) => {
                                this.onInputAutoComplete(indexLevel, indexRule, 'rule', value);
                            }}
                            filter={this.filterAutoComplete}
                            textFieldStyle={{ fontSize: '13px' }}
                            listStyle={{ overflow: 'auto', maxHeight: '300px', fontSize: '13px' }}
                            popoverProps={{
                                style: { width: 'auto' },
                                canAutoPosition: true,
                            }}
                            fullWidth
                            disabled={disabledActions}
                        />
                    </div>
                    <div className="col-xs-4">
                        <AutoComplete
                            searchText={rule._type}
                            dataSource={types}
                            floatingLabelText='Type'
                            onUpdateInput={(value) => {
                                this.onInputAutoComplete(indexLevel, indexRule, '_type', value);
                            }}
                            filter={this.filterAutoComplete}
                            textFieldStyle={{ fontSize: '13px' }}
                            listStyle={{ overflow: 'auto', maxHeight: '300px', fontSize: '13px' }}
                            popoverProps={{
                                style: { width: 'auto' },
                                canAutoPosition: true,
                            }}
                            disabled={disabledActions}
                            fullWidth
                        />
                    </div>
                    {
                        !disabledActions ?
                            <Fragment>
                                <div className="col-xs-2">
                                    <ColorPickerPopup
                                        indexLevel={indexLevel}
                                        indexRule={indexRule}
                                        color={rule.color}
                                        changeColor={this.changeColor}
                                    />
                                </div>
                                <div className="col-xs-2">
                                    <IconButton>
                                        <ContentRemoveIcon
                                            onClick={() => {
                                                this.removeRule(indexLevel, indexRule);
                                            }}
                                            color='red'
                                            disabled={disabledActions}
                                        />
                                    </IconButton>
                                </div>
                            </Fragment>
                            :
                            ''
                    }
                </div>
                <div style={{ height: '5px', background: rule.color }}>

                </div>
            </div>
        )
    }
}

RuleItem.propTypes = {
    annotations: PropTypes.array,
    changeLevelList: PropTypes.func,
    levelList: PropTypes.array,
    indexLevel: PropTypes.number,
    indexRule: PropTypes.number,
    rule: PropTypes.object,
    disabledActions: PropTypes.bool,
};

export default connect(
    ({ annotations }, { changeLevelList, levelList, indexLevel, indexRule, rule, disabledActions }) => {
        return {
            annotations: annotations.items,
            changeLevelList,
            levelList,
            indexLevel,
            indexRule,
            rule,
            disabledActions,
        };
    },
    dispatch => ({}),
)(RuleItem);



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Gazetter/Sidebar/RuleItem.jsx